<template>
  <div class="content">

      <div class="form-wrap">
        <el-input class="input mgr10" v-model="keyword" placeholder="请输入内容搜索" clearable></el-input>
        <el-select class="select mgr10" v-model="type" placeholder="请选择排序方式">
            <el-option v-for="(item, idx) in items" 
            :key="idx" :label="item.label" :value="item.val"></el-option>
        </el-select>
        <el-checkbox class="mgr10" v-model="checked">{{checked ? '启用' : '禁用'}}</el-checkbox>
        <el-button type="danger" @click="search">搜索</el-button>
      </div>


      <el-table
        v-loading = "pictLoading"
        border
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">

        <!-- 姓名 -->
            <el-table-column
                prop="name"
                :label="$t('name')">
            </el-table-column>

            <el-table-column
                prop="mobile"
                label="手机号">
            </el-table-column>

            <!-- 头像 -->
            <el-table-column
                :label="$t('avatar')"
               >
                <template slot-scope="scope">
                    <img :src="scope.row.avatar" alt="" class="avatar">
                </template>
            </el-table-column>

            <!-- 状态 -->
            <el-table-column
                prop="status"
                label="状态">
            </el-table-column>
            <!-- 佣金比例 -->
            <el-table-column
                prop="rebate"
                label="佣金比例(%)">
            </el-table-column>

            <!-- 添加时间 -->
            <el-table-column
                prop="ctime"
                :label="$t('addTime')">
            </el-table-column>

            <!-- 订单数 -->
            <el-table-column
                prop="order_num"
                :label="$t('orderNum')">
            </el-table-column>

            <!-- 用户数量 -->
            <el-table-column
                prop="user_num"
                :label="$t('userNum')">
            </el-table-column>
            <!-- 可提佣金 -->
            <el-table-column
                prop="sales_money"
                :label="$t('butCommission')">
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('action')"
                
                width="120">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="userOrder(scope.row)">
                        <!-- 订单 -->
                        {{$t('orders')}}
                    </el-button>
                    <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">
                        <!-- 编辑 -->
                        {{$t('edit')}}
                    </el-button>
                    <el-button type="text" size="small" @click="delUser(scope.row, scope.$index)">
                        <!-- 删除 -->
                        {{$t('del')}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <Pagination
            v-if="tableData.length>0"
            :totalPage="totalPage"
            :limit="limit"
            @changePage="handleCurrentChange"
        ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            tableData: [],
            page: 1,
            limit: 10,
            totalPage: 0,
            items: [
                {label: "佣金比例↑",     val: 'proportion-asc'},
                {label: "佣金比例↓",     val: 'proportion-desc'},
                {label: "订单数↑",     val: 'order-asc'},
                {label: "订单数↓",     val: 'order-desc'},
                {label: "用户数↑",     val: 'user-asc'},
                {label: "用户数↓",     val: 'user-desc'},
               
            ],
            keyword: '',
            type: '',
            checked: true,
            pictLoading: true,

        }
    },
    methods:{
        userOrder(val) {
            this.$router.push({
                name: 'stafforder',
                query: {id: val.id}
            })
        },
        handleCurrentChange() {
            this.page += 1
            this.list()
        },
        delUser(v, index) {
            const _this = this
            this.$alert( _this.$t('deleteUser') + v.name, {
                confirmButtonText: _this.$t('confirm'), // '确定',
                callback: action => {
                    
                    _this.$api.delstaff({id: v.id}).then( res => {
                        if(res.status) {
                            _this.$message({
                                message: _this.$t('successfullyDelete') // "删除成功"
                            })
                            _this.tableData.splice(index, 1)
                        } else {
                             _this.$message({
                                message: _this.$t('failed')// "删除失败"
                            })
                        }
                    })
                }
            });
            // alert(v.id)
        },
        handleClick(val, type) {
            if(type == 'edit') {
                this.$router.push({
                    name: 'staffadd',
                    query: {id: val.id}
                })
            }
//    12312311321321
        },
        search() {
            this.page = 1
            this.list()
        },
        list() {
            this.pictLoading = true
            let form = {
                id: window.localStorage.getItem('businessId'),
                page: this.page,
                limit: this.limit
            }
            if(this.type) {
                let arr = this.type.split('-')
                form.order = {}
                form.order.key = arr[0]
                form.order.sort = arr[1]
            }
            form.where = {}
            form['where']['status'] = this.checked ? 1 : 2
            this.keyword && (form.keyword = this.keyword)
            this.$api.getstafflists(form).then(res =>{
                    if(res.status) {
                        this.tableData = res.data.data

                        this.totalPage = Math.ceil(res.data.count / this.limit) 
                    }
                    this.pictLoading = false
                })
        }
    },
    created() {
        console.log(123213)
        this.list()
    },
    
}
</script>

<style lang="scss" scoped>
.avatar{
    width: 24px;
    height: 24px;
}

.form-wrap{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .input {
        width: 300px;
    }
}

.mgr10 {
    margin-right: 10px;
}
</style>